import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ClientService} from '../../../Services/client.service';
import {AuthService} from '../../../auth/AuthService';
import {first} from 'rxjs/operators';
import swal from 'sweetalert2';
import {ActivatedRoute, Router} from '@angular/router';
import {IOffice} from '../../../Model/Office';
import {OfficeService} from '../../../Services/office.service';
import {statesDropdown} from '../../../shared/StatesUS';
import {PayerService} from '../../../Services/payer.service';

@Component({
    selector: 'pm-create-payer',
    templateUrl: './create-payer.component.html',
    styleUrls: ['./create-payer.component.css']
})
export class CreatePayerComponent implements OnInit {
    payerForm!: FormGroup;
    PayerId: any;
    status: boolean = false;
    clientList: any = [];
    phoneType: any = [
        {value: 'Mobile', viewValue: 'Mobile'},
        {value: 'Work', viewValue: 'Work'},
        {value: 'Home', viewValue: 'Home'},
    ];
    stateList: any = statesDropdown;

    constructor(private fb: FormBuilder,
                private clientServices: ClientService,
                private payerService: PayerService,
                private authService: AuthService,
                private activatedRoute: ActivatedRoute,
                private route: Router) {

        this.PayerId = this.activatedRoute.snapshot.paramMap.get('id');

        this.payerForm = this.fb.group({
            name: [null, Validators.required],
            payerIdCode: [null, Validators.required],
        });

        if (this.PayerId) {
            let reqData: any = {
                id: this.PayerId
            };
            this.payerService.getPayerDetails(reqData).pipe(first()).subscribe(
                (response: any) => {
                    if (response != undefined) {
                        let data = response;
                        this.status = data.active ? data.active : false;
                        this.payerForm.patchValue({
                            id: data.id,
                            name: data?.name ? data.name : null,
                            payerIdCode: data?.payerIdCode ? data.payerIdCode : null,
                        });
                    } else {
                        swal.fire({
                            title: 'Error!',
                            icon: 'error',
                            text: response.message,
                            showConfirmButton: false,
                            timer: 5000
                        });
                    }
                },
                (error) => {
                    swal.fire({
                        title: 'Error!',
                        icon: 'error',
                        text: error.error.message,
                        showConfirmButton: false,
                        timer: 5000
                    });
                }
            );
        }
    }

    ngOnInit(): void {
        //this.payerForm.get('clientId')?.disable();
    }


    // Change status
    changeStatus(status: any) {
        if (status == true) {
            this.status = false;
        } else {
            this.status = true;
        }
    }

    // Register client function / update
    onRegister(): any {
        this.payerForm.markAllAsTouched();
        if (this.payerForm.valid) {
            let reqData = {
                name: this.payerForm.controls.name.value ? this.payerForm.controls.name.value : null,
                payerIdCode: this.payerForm.controls.payerIdCode.value ? this.payerForm.controls.payerIdCode.value : null,
            };

            // update logic
            if (this.PayerId) {
                let params = {
                    id: this.PayerId,
                };
                this.payerService.updatePayer(reqData, params).pipe(first()).subscribe(
                    (response: any) => {
                        if (response != undefined) {
                            this.route.navigate(['payer']);
                            swal.fire({
                                icon: 'success',
                                text: 'Payer :- ' + `" ${reqData.name} "` + ' updated successfully.',
                                showConfirmButton: false,
                                timer: 3000
                            });
                        } else {
                            swal.fire({
                                title: 'Error!',
                                icon: 'error',
                                text: response.message,
                                showConfirmButton: false,
                                timer: 5000
                            });
                        }
                    },
                    (error) => {
                        swal.fire({
                            title: 'Error!',
                            icon: 'error',
                            text: error.error.message,
                            showConfirmButton: false,
                            timer: 5000
                        });
                    }
                );
            }
            // add / register logic
            else {
                this.payerService.addPayer(reqData).pipe(first()).subscribe(
                    (response: any) => {
                        if (response != undefined) {
                            this.route.navigate(['payer']);
                            swal.fire({
                                icon: 'success',
                                text: 'Payer :- ' + `" ${reqData.name} "` + ' registered successfully.',
                                showConfirmButton: false,
                                timer: 3000
                            });
                        } else {
                            swal.fire({
                                title: 'Error!',
                                icon: 'error',
                                text: response.message,
                                showConfirmButton: false,
                                timer: 5000
                            });
                        }
                    },
                    (error) => {
                        swal.fire({
                            title: 'Error!',
                            icon: 'error',
                            text: error.error.message,
                            showConfirmButton: false,
                            timer: 5000
                        });
                    }
                );
            }

        }
    }

}
